import {Brick, registerBrick, Config, ErrorFlow} from 'olympe';
import {Base64} from 'js-base64';

/**
 * GetSAMLDetails
 */
export default class GetSAMLDetails extends Brick {
    /**
     * Executed every time the brick receives a new trigger event.
     * Note that the method will be executed _even if_ an input () is undefined.
     *
     * @protected
     * @param {BrickContext} context
     * @param {!Array} inputs
     * @param {function()} forwardEvent
     * @param {function(string)} setUsername
     * @param {function(string)} setFullName
     * @param {function(string)} setEmail
     * @param {function(string)} setSAMLToken
     * @param {function(ErrorFlow)} setErrorFlow
     */
    update(context, [dbKey], [forwardEvent, setUsername, setFullName, setEmail, setSAMLToken, setErrorFlow]) {
        const olympeDB = Config.getParameter('saml.olympe_db');
        const store = Config.getParameter('saml.db_store');
        const key = Config.getParameter(dbKey);

        const DBConnexion = indexedDB.open(olympeDB);
        DBConnexion.onerror = (event) => {
            console.error(`Error opening the Olympe Local DB ${event}`);
            setErrorFlow(ErrorFlow.create(`Error opening the Olympe Local DB ${event}`, 1));
        };

        DBConnexion.onsuccess = (event) => {
            const db = event.target.result;
            const transaction = db.transaction([store], 'readonly');
            const authStore = transaction.objectStore(store);
            const request = authStore.get(key);

            request.onsuccess = (event) => {
                const data = event.target.result;
                const details = data ? decodeURIComponent(Base64.decode(data)) : '{}';
                const userData = JSON.parse(details);

                if (!userData.payload) {
                    console.error('No SAML payload');
                    db.close();
                    setErrorFlow(ErrorFlow.create('No SAML payload', 2));
                } else if (userData.payload['http://schemas.microsoft.com/identity/claims/identityprovider'] !== Config.getParameter('saml.identity_provider')) {
                    db.close();
                    setErrorFlow(ErrorFlow.create('Unauthorized', 3));
                } else {
                    setUsername(userData.payload['nameId']);
                    setFullName(
                        userData.payload['http://schemas.xmlsoap.org/ws/2005/05/identity/claims/givenname'] +
                        ' ' +
                        userData.payload['http://schemas.xmlsoap.org/ws/2005/05/identity/claims/surname'],
                    );
                    setEmail(userData.payload['http://schemas.xmlsoap.org/ws/2005/05/identity/claims/emailaddress']);
                    setSAMLToken(userData.payload.fullToken);
                    db.close();
                    forwardEvent();
                }
            };
            request.onerror = (event) => {
                db.close();
                console.error('Error getting the SAML data');
                setErrorFlow(ErrorFlow.create('Error getting the SAML data', 3));
            };
        };
    }
}

registerBrick('017dd778cfb7d43d99df', GetSAMLDetails);
